export const STAGES = {
  START: 'start',
  WAITING: 'waiting',
  PLAYING: 'playing',
  RECORDING: 'recording',
  COMPLETE: 'complete',
};

export const STEPS = {
  STRUCTURE: 'structure',
  CHECK_HEADSET: 'checkHeadset',
  CHECK_MICROPHONE: 'checkMicrophone',
  CHECK_KEYBOARD: 'checkKeyboard',
  INTRODUCTION: 'introduction',
  DESCRIPTION: 'description',
  NOTE: 'note',
};

export const stepsOrder = [
  STEPS.STRUCTURE,
  STEPS.CHECK_HEADSET,
  STEPS.CHECK_MICROPHONE,
  STEPS.CHECK_KEYBOARD,
  STEPS.INTRODUCTION,
  STEPS.DESCRIPTION,
  STEPS.NOTE,
];
